import React, { ReactNode } from 'react';
import * as MeasureDisplayFormatUI from './MeasureDisplayFormatUI';

interface IProps {
  children: ReactNode;
}

const MeasureDisplayFormatCalculation = ({ children }: IProps) => {
  return (
    <MeasureDisplayFormatUI.FormRow>
      <MeasureDisplayFormatUI.FormLabel>
        Calculation
      </MeasureDisplayFormatUI.FormLabel>
      <MeasureDisplayFormatUI.CalculationContainer>
        {children}
      </MeasureDisplayFormatUI.CalculationContainer>
    </MeasureDisplayFormatUI.FormRow>
  );
};

export default MeasureDisplayFormatCalculation;
